<div class="custella-login">
    <a class="fe-brand">
      <img src="../../../assets/svg/FieldEx_Logo_Full_W.svg" alt="FieldEx" />
    </a>

     <div class="container">
    <div class="row">
      <div class="mx-auto">
        <div class="card setup-card border-0 shadow-none rounded-3 my-5">
          <div class="card-body p-0">
            <div class="setup-panel">
              <h2 class="setup-title">Thank you for signing up</h2>

              <div class="setup-hero">
                <!-- you’ll replace this img src with your artwork -->
                <img class="setup-illustration" src="../../../assets/svg/CheckEmail_NoRedDot.svg" alt="Check your email" />
              </div>

              <div class="setup-text">
                <div class="setup-lead">Just open your email on a desktop, click the link we sent, and continue setting up FieldEx.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>